module.exports = __webpack_public_path__ + "static/media/step_detail_career_du_lich_mobile.11762815.jpg";